import * as z from "zod";

export const updateOrderSyncFunction = {
  name: "updateOrderSyncFunction" as const,
  input: z.object({ artifactId: z.string().optional() }),
  output: z.object({}),
};
